<template>
	<main>
		<component 
			:is="currentComponent"
			@createPin="createPin"
			@confirmPin="confirmPin"
			@authPin="authPin"
		></component>
	</main>
</template>
<script>
	import { mapState } from 'vuex'
	import SettingPinForm from './pin/SettingPinForm.vue'
	import SettingPinFormConfirmation from './pin/SettingPinFormConfirmation.vue'
	import AuthPinForm from './pin/AuthPinForm.vue'

	export default {
		computed: {
			...mapState('user', {
				userPin: 'pin'
			})
		},
		components: {
			SettingPinForm,
			SettingPinFormConfirmation,
			AuthPinForm
		},
		methods: {
			authPin(pin) {
				this.currentComponent = 'SettingPinForm'
			},
			createPin(pin) {
				this.$store.dispatch('user/setPin', pin)
				this.currentComponent = 'SettingPinFormConfirmation'
			},
			confirmPin(pin) {
				this.$vs.loading()

				const url = this.userPin == null ? 'user/createPin' : 'user/changePin'
				const payload = this.userPin == null ? { pin } : { pin, old_pin: this.userPin }

				this.$store.dispatch(url, payload)
				.then(() => {
					this.$vs.loading.close()
					this.$vs.notify({
						title: 'PIN Saldo Berhasil Diperbaharui',
						text: '',
						color: 'success',
						position: 'top-right'
					})

					setTimeout(() => {
						this.$emit('successChangePIN')
					}, 500)
				})
				.catch(e => {
					this.$vs.loading.close()
					console.error(e)
					this.showError(e)

					return false
				})
					
			}
		},
		data: () => ({
			isActive: false,
			currentComponent: 'AuthPinForm'
		}),
		created() {
			if(this.userPin) {
				this.currentComponent = 'AuthPinForm'
			}
			else {
				this.currentComponent = 'SettingPinForm'
			}

		}
	}
</script>